import BaseApi from './base/base-api';

class AuthUserApi extends BaseApi {
  constructor(baseURL: string) {
    super(baseURL, {
      allowRefreshToken: true,
      includeAuthorization: true,
    });

    this.axios.interceptors.request.use(
      (config: any) => {
        config.headers = {
          ...config.headers,
          'api-key': process.env.REACT_APP_NEW_API_KEY,
        };
        return config;
      },
      (error: any) => Promise.reject(error),
    );
  }
}

export default new AuthUserApi(process.env.REACT_APP_NEW_AUTH_API_URL || '');
